import { render, staticRenderFns } from "./DescriptionAndFees.vue?vue&type=template&id=2c9cec3a&"
import script from "./DescriptionAndFees.vue?vue&type=script&lang=js&"
export * from "./DescriptionAndFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports